import styled from 'styled-components'

export const ListWrapper = styled.ul<{ space?: string }>`
  list-style-type: none;
  padding: 0;
  margin: 0;
`
